import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { distinctUntilChanged, map, startWith, takeUntil } from 'rxjs/operators';

import isEqual from 'lodash-es/isEqual';
import { BaseContainer } from '../../../../../core/common/containers/base.abstract.container';
import { BaseNestedFieldDefinition } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { ShFormMultiSelectModule } from '../../../../../form-controls/components/form-multi-select/form-multi-select.module';
import { MultiFormSelectOptions } from '../../../../../form-controls/entities/multi-form-select-options.entity';
import { AdvancedSearchDialogTranslations } from '../../../entities/i18n/advanced-search-translations.entity';
import { BaseAdvancedSearchSandbox } from '../../../sandbox/advanced-search.sandbox';

@Component({
    standalone: true,
    selector: 'sh-advanced-search-row-field',
    templateUrl: './advanced-search-row-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShFormMultiSelectModule]
})
export class ShAdvancedSearchRowFieldComponent extends BaseContainer implements OnInit {
    @Input() id!: string;
    @Input() i18n!: AdvancedSearchDialogTranslations;
    @Input() label!: string;
    @Input() profileFields!: ExtendedBaseProfileField<BaseNestedFieldDefinition>[];
    @Input() options!: MultiFormSelectOptions;
    @Input() isHeader = false;
    @Input() searchPlaceholder!: string;

    @Input() control!: UntypedFormControl;

    public internalControl: UntypedFormControl = new UntypedFormControl();

    constructor(private readonly sandbox: BaseAdvancedSearchSandbox<BaseNestedFieldDefinition>) {
        super();
    }

    ngOnInit(): void {
        this.initInternalControlValueChangesListener();
        this.initExternalControlValueChangesListener();
    }

    private initInternalControlValueChangesListener(): void {
        this.internalControl.valueChanges
            .pipe(
                distinctUntilChanged(isEqual),
                map(fieldDef =>
                    fieldDef && fieldDef.length > 0
                        ? this.profileFields.find(field => field.FieldDefinition.DottedKey === fieldDef[0])
                        : null
                ),
                takeUntil(this.destroy$)
            )
            .subscribe(value => this.control.setValue(value));
    }

    private initExternalControlValueChangesListener(): void {
        this.control.valueChanges
            .pipe(startWith(this.control.value), distinctUntilChanged(isEqual), takeUntil(this.destroy$))
            .subscribe((profileField: ExtendedBaseProfileField<BaseNestedFieldDefinition>) => {
                this.internalControl.setValue(
                    profileField ? [this.sandbox.profileFieldToTypeSelectOption(profileField).value] : []
                );
            });
    }
}
